export const topics = [
  {
    topic: "arrays",
    keywords: [
      "array", "arrays", "java arrays", "array syntax", "array example",
      "array operations", "array traversal", "array sorting", "dynamic array",
      "array interview questions", "array complexity", "java array initialization",
      "what is an array", "how to use arrays", "why use arrays", "types of arrays",
      "how to declare array in java", "how to traverse an array", "how to sort an array"
    ]
  },
  {
    topic: "linkedlist",
    keywords: [
      "linked list", "singly linked list", "doubly linked list",
      "linkedlist implementation", "java linkedlist", "linkedlist operations",
      "linkedlist interview questions", "linked list traversal", "linked list insertion",
      "linked list deletion", "linked list complexity", "java linked list example",
      "what is a linked list", "how to implement a linked list", "why use linked list",
      "how does linked list work", "difference between singly and doubly linked list"
    ]
  },
  {
    topic: "stack",
    keywords: [
      "stack", "stack java", "stack implementation", "stack push pop",
      "stack interview questions", "stack syntax", "stack example",
      "stack applications", "stack in java collections",
      "what is a stack", "how does stack work", "why use stack",
      "stack vs queue", "stack operations in java", "how to implement a stack"
    ]
  },
  {
    topic: "queue",
    keywords: [
      "queue", "queue java", "queue implementation", "queue operations",
      "queue interview questions", "queue example", "queue syntax",
      "priority queue", "circular queue",
      "what is a queue", "how to implement a queue", "why use queue",
      "difference between queue and stack", "types of queues", "how does a queue work"
    ]
  },
  {
    topic: "trees",
    keywords: [
      "tree", "trees", "binary tree", "binary search tree", "bst", "tree traversal",
      "preorder", "inorder", "postorder", "tree implementation java",
      "tree interview questions", "avl tree", "red black tree",
      "what is a tree in data structure", "how to traverse a tree", "why use trees",
      "difference between binary tree and binary search tree", "how to implement a tree"
    ]
  },
  {
    topic: "graphs",
    keywords: [
      "graph", "graphs", "graph java", "graph implementation",
      "graph traversal", "dfs", "bfs", "graph interview questions",
      "adjacency list", "adjacency matrix", "weighted graph", "directed graph",
      "what is a graph", "how graph works", "why use graphs",
      "difference between dfs and bfs", "how to implement a graph"
    ]
  },
  {
    topic: "sorting",
    keywords: [
      "sorting", "sorting algorithms", "bubble sort", "merge sort",
      "quick sort", "insertion sort", "selection sort", "heap sort",
      "java sorting", "sorting interview questions", "time complexity sorting",
      "what is sorting", "how sorting works", "why sorting is important",
      "which sorting algorithm is best", "how to sort an array"
    ]
  },
  {
    topic: "searching",
    keywords: [
      "searching", "linear search", "binary search", "search algorithms",
      "search java", "search interview questions", "search complexity",
      "binary search java", "search in array",
      "what is searching", "how searching works", "types of searching",
      "difference between linear and binary search", "how to implement binary search"
    ]
  },
  {
    topic: "dynamicprogramming",
    keywords: [
      "dynamic programming", "dp", "memoization", "tabulation",
      "dp java", "dp interview questions", "longest common subsequence",
      "knapsack problem", "fibonacci dp", "dynamic programming example",
      "what is dynamic programming", "how dp works", "why use dp",
      "difference between memoization and tabulation", "how to solve dp problems"
    ]
  },
  {
    topic: "develop",
    keywords: [
      "develop", "developer", "website", "about", "contact",
      "what is website development", "how to become a developer", "why development matters",
      "how to build a website", "what does a developer do"
    ]
  }
];